import { letenky } from './postInitHook'

export let formId = null
export const setFormId = id => formId = id

let loaded = false

export let bindForm = opts => {
  $('.show-hide-form').on('click', function() {
    if(loaded) {
      $('#airticket-map-form').removeClass('form-closed')
      return
    }

    opts.form.initFunction(letenky)

    loaded = true
  })

  $('body').on('click', '.close-form', function() {
    $('#airticket-map-form').addClass('form-closed')
  })
}



// WEBPACK FOOTER //
// ./app/form/bindForm.js